import React from 'react'
import Text from '../../components/text/Text'
import greenCheck from '../../assets/icons/light-green-check.png'
import './cashPayment.css'
import routes from '../../router/routes'
import { useLocation, useNavigate } from 'react-router-dom'
import SvgIcon from '../../components/svgIcon/SvgIcon'

const CashPayment = () => {
    const navigation = useNavigate()
    const location = useLocation()

    const file = location.state?.fileInvoice

    const navigateBack = () => {
        navigation(`/${routes.payment}`)
    }

    const openPdf = () => {
        const byteCharacters = atob(file)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        window.open(url)
    }

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 20,
                    borderRadius: 10,
                }}
            >
                <img
                    src={greenCheck}
                    style={{ marginBottom: 10, width: 110, height: 110 }}
                />
                <Text
                    label="Se registró una venta con efectivo."
                    fontFamily={'Poppins'}
                    fontWeight={700}
                    textAlign="center"
                    color={'#676767'}
                />
                <Text
                    label="Recuerda que los registros de efectivo"
                    fontFamily={'Poppins'}
                    textAlign="center"
                    color={'#676767'}
                />
                <Text
                    label="no será registrado en la proforma amiPASS."
                    fontFamily={'Poppins'}
                    textAlign="center"
                    fontWeight={700}
                    color={'#676767'}
                />
                <div style={{ marginTop: 15, marginBottom: 5 }}>
                    {file ? (
                        <button
                            onClick={openPdf}
                            style={{
                                gap: 7,
                                display: 'flex',
                                cursor: 'pointer',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textDecoration: 'underline',
                                backgroundColor: 'transparent',
                            }}
                        >
                            <Text
                                label="Descargar la boleta en PDF"
                                variant="bold"
                            />
                            <SvgIcon iconName="PdfIcon" />
                        </button>
                    ) : (
                        <div
                            style={{
                                gap: 7,
                                maxWidth: 350,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <div style={{ width: 30 }}>
                                <SvgIcon iconName="warning" />
                            </div>
                            <Text
                                variant="Caption3-13"
                                label="Se presentó un problema para generar la boleta electrónica. Por favor contacta a nuestro equipo de soporte."
                            />
                        </div>
                    )}
                </div>
                <div className="cashButton" onClick={navigateBack}>
                    <Text
                        label="Realizar otra venta"
                        fontWeight={600}
                        color={'white'}
                        fontSize={16}
                        fontFamily={'Montserrat'}
                    />
                </div>
            </div>
        </div>
    )
}

export default CashPayment
